import { createSlice } from '@reduxjs/toolkit';
import { openSection } from './utils';

export interface DocsMenuState {
  data: {
    openedSections: { [key: string]: boolean };
    openedCategory: string;
  };
  status: 'idle' | 'loading' | 'failed';
}

const initialState: DocsMenuState = {
  data: {
    openedSections: {},
    openedCategory: '',
  },
  status: 'idle',
};

export const docsMenuSlice = createSlice({
  name: 'docsMenu',
  initialState,
  reducers: {
    updateOpenedSections: (state, action) => {
      const linkClicked = action.payload.linkClicked;
      const linkArray = linkClicked.split('/');

      const pathArray = linkArray.splice(1);
      const categoryName = linkArray[0];

      if (categoryName !== state.data.openedCategory) {
        state.data.openedSections = {};
        state.data.openedCategory = categoryName;
      }

      state.data.openedSections = openSection(
        pathArray,
        state.data.openedSections,
      );
    },
  },
});

export default docsMenuSlice.reducer;
